import { Nullable } from "@intentsify/types";
import { apiService, Endpoints } from "api";

export const getAdSolutionsReportDateRange = async (campaignId: string) => {
  const { data } = await apiService.get<{
    startDate: Nullable<string>;
    endDate: Nullable<string>;
  }>(
    Endpoints.Reports.CumulativeReport.Get.AdSolutionsReportDateRange(
      campaignId
    )
  );

  return data;
};
